var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loader',[(_vm.redirectRoute)?_c('Redirect',{attrs:{"slot":"loadedContent","options":_vm.redirectRoute},slot:"loadedContent"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }